import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '../../theme';
import SectionLabel from '../shared/SectionLabel';

const USERS = [
  'june_t', 'theo_l', 'marisol_v', 'ghostpilot', 'neon_rider', 'kestrel_99',
  'murphy0091', 'BigFootTommy', 'dusty_rhodes', 'starfall_x', 'cometjane',
  'blueshift22', 'oldpal_mike', 'wanderlost', 'hex_nova', 'quietstorm',
];
const PLATFORMS = ['Steam', 'Xbox', 'PSN', 'Discord'];

function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

function generateEntry(minutesAgo) {
  const r = Math.random();
  if (r < 0.12) return { time: minutesAgo, text: `reconnection confirmed: 2 users matched on ${pick(PLATFORMS)}`, special: true };
  if (r < 0.2) return { time: minutesAgo, text: `new user registered from ${pick(PLATFORMS)}`, special: true };
  const a = pick(USERS);
  let b = pick(USERS);
  while (b === a) b = pick(USERS);
  const actions = ['filed a tag for', 'searched for', 'wrote back to'];
  return { time: minutesAgo, text: `${a} ${pick(actions)} ${b} on ${pick(PLATFORMS)}`, special: false };
}

function initialFeed() {
  const mins = [2, 5, 8, 14, 21, 27, 31, 38, 44];
  return mins.map(m => ({ ...generateEntry(m), id: Math.random() }));
}

export default function LiveFeed() {
  const { p, d, fonts } = useTheme();
  const [feed, setFeed] = useState(initialFeed);
  const counter = useRef(0);

  useEffect(() => {
    const id = setInterval(() => {
      counter.current += 1;
      setFeed(prev => {
        const entry = { ...generateEntry(0), id: counter.current, fresh: true };
        const next = [entry, ...prev.slice(0, 8)];
        return next;
      });
    }, 8000 + Math.random() * 4000);
    return () => clearInterval(id);
  }, []);

  function formatTime(m) {
    if (m === 0) return 'just now';
    if (m < 60) return `${m}m ago`;
    return `${Math.floor(m / 60)}h ago`;
  }

  return (
    <section style={{
      padding: `${d.gap * 2.5}px ${d.pad}px`,
      borderBottom: `1px solid ${p.border}`,
    }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <SectionLabel>§ 05 / live from the index</SectionLabel>

        <h2 style={{
          fontFamily: fonts.serif, fontSize: 48, fontWeight: 400,
          letterSpacing: '-.03em', lineHeight: 1, margin: '0 0 6px',
          color: p.textHi,
        }}>
          The index is alive.
        </h2>
        <p style={{
          fontFamily: fonts.serif, fontStyle: 'italic', fontSize: 15,
          color: p.textDim, margin: '0 0 40px',
        }}>
          Right now, people are reconnecting.
        </p>

        <div style={{
          border: `1px solid ${p.border}`,
          background: p.bgPanel,
          padding: '4px 0',
          maxHeight: 340,
          overflow: 'hidden',
        }}>
          {feed.map((item) => (
            <div key={item.id} className={item.fresh ? 'feed-enter' : ''} style={{
              padding: '12px 24px',
              borderBottom: `1px dashed ${p.border}`,
              display: 'flex',
              alignItems: 'baseline',
              gap: 16,
              fontFamily: fonts.mono,
              fontSize: 12.5,
            }}>
              <span style={{
                color: p.textFaint, minWidth: 56, fontSize: 11,
                letterSpacing: '.04em',
              }}>
                {formatTime(item.time)}
              </span>
              <span style={{
                color: item.special ? p.accent : p.text,
                fontStyle: item.special ? 'italic' : 'normal',
              }}>
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes feedSlideIn {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .feed-enter { animation: feedSlideIn .4s ease-out; }
      `}</style>
    </section>
  );
}
